import { createRouter, createWebHistory } from 'vue-router'
import { supabase, getReadySession } from '@/lib/supabase'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import ForgotPasswordView from '../views/ForgotPasswordView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import ChangePasswordView from '../views/ChangePasswordView.vue'
import ProfileView from '../views/Settings.vue'
import PublicProfileView from '../views/PublicProfileView.vue'
import AuthCallback from '../views/AuthCallback.vue'
import FeedView from '../views/FeedView.vue'
import PostView from '../views/PostView.vue'
import NotificationsView from '../views/NotificationsView.vue'
import MessagesView from '../views/MessagesView.vue'
import AdminDashboard from '../views/AdminDashboard.vue'
import ReportIssueView from '../views/ReportIssueView.vue'
import TournamentRoomsView from '../views/TournamentRoomsView.vue'
import TournamentRoomDetailView from '../views/TournamentRoomDetailView.vue'
import LocalMeetsView from '../views/LocalMeetsView.vue'
import LocalMeetDetailView from '../views/LocalMeetDetailView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    meta: { auth: true },
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    meta: { auth: true },
    component: RegisterView
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPasswordView
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPasswordView
  },
  {
    path: '/change-password',
    name: 'change-password',
    meta: { requiresAuth: true },
    component: ChangePasswordView
  },
  {
    path: '/profile',
    name: 'profile',
    meta: { requiresAuth: true },
    component: ProfileView
  },
  {
    path: '/feed',
    name: 'feed',
    meta: { requiresAuth: true },
    component: FeedView
  },
  {
    path: '/post/:id',
    name: 'post',
    meta: { requiresAuth: true },
    component: PostView
  },
  {
    path: '/notifications',
    name: 'notifications',
    meta: { requiresAuth: true },
    component: NotificationsView
  },
  {
    path: '/messages/:handle?',
    name: 'messages',
    meta: { requiresAuth: true },
    component: MessagesView
  },
  {
    path: '/report',
    name: 'report',
    meta: { requiresAuth: true },
    component: ReportIssueView
  },
  {
    path: '/meets',
    name: 'meets',
    meta: { requiresAuth: true },
    component: LocalMeetsView
  },
  {
    path: '/meets/:id',
    name: 'meet-detail',
    meta: { requiresAuth: true },
    component: LocalMeetDetailView
  },
  {
    path: '/tournament',
    name: 'tournament',
    meta: { requiresAuth: true },
    component: TournamentRoomsView
  },
  {
    path: '/tournament/room/:id',
    name: 'tournament-room',
    meta: { requiresAuth: true },
    component: TournamentRoomDetailView
  },
  {
    path: '/admin',
    name: 'admin',
    meta: { requiresAdmin: true },
    component: AdminDashboard
  },
  {
    path: '/u/:handle',
    name: 'public-profile',
    component: PublicProfileView
  },
  {
    path: '/auth/callback',
    name: 'auth-callback',
    component: AuthCallback
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) return { ...savedPosition, behavior: 'smooth' }
    return { top: 0, left: 0, behavior: 'smooth' }
  }
})

router.beforeEach(async (to) => {
  const session = await getReadySession()
  const user = session?.user

  if (to.path === '/' && user) {
    return { path: '/feed', replace: true }
  }

  if (to.meta?.requiresAuth && !user) {
    return { path: '/login', replace: true }
  }

  if (to.meta?.auth && user) {
    return { path: '/feed', replace: true }
  }

  if (to.meta?.requiresAdmin) {
    if (!user) {
      return { path: '/login', replace: true }
    }

    const { data: profile } = await supabase.from('profiles').select('role, status').eq('id', user.id).maybeSingle()

    if (!profile || profile.status === 'banned') {
      return { path: '/login', replace: true }
    }

    if (profile.role !== 'admin') {
      return { path: '/feed', replace: true }
    }
  }

  return true
})

// router.beforeResolve((to, from) => {
//   if (typeof window === 'undefined') return true
//   if (!from?.matched?.length) return true
//   if (to.fullPath === from.fullPath) return true
//   if (window.__drvnRouteReloadTarget === to.fullPath) {
//     window.__drvnRouteReloadTarget = null
//     return true
//   }
//
//   window.__drvnRouteReloadTarget = to.fullPath
//   window.location.assign(router.resolve(to).href)
//   return false
// })

export default router
